import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import Button from "../../shared/Button";
import InputWithlabelin from "../../shared/InputWithlabelin";

const CreateStepPart2 = ({prevStep,nextStep}) => {
  const { updatePlaceDetail, createInfoData ,apiUpdateResideces,setIsEditPlaceCompleter} = useCreatePlace();

  const { formState: { errors, isValid }, control,handleSubmit } = useForm({
  defaultValues:{
    shortdate:createInfoData.stepthirteen.general_discount[0].day_count,
    shortpercentage:createInfoData.stepthirteen.general_discount[0].percentage_amount,
    longdate:createInfoData.stepthirteen.general_discount[1].day_count,
    longpercentage:createInfoData.stepthirteen.general_discount[1].percentage_amount
  }
  });

  const {id}=useParams()

  const onSubmit = data=>{
   updatePlaceDetail("stepthirteen",{
    general_discount: [
      {
        discount_type: "short",
        percentage_amount: data.shortdate,
        day_count: data.shortpercentage
      },
      {
        discount_type: "long",
        percentage_amount: data.longdate,
        day_count: data.longpercentage
      }
    ]
   })
  nextStep()
  }
    const update = (data) => {
      updatePlaceDetail("stepthirteen",{
        general_discount: [
          {
            discount_type: "short",
            percentage_amount: data.shortdate,
            day_count: data.shortpercentage
          },
          {
            discount_type: "long",
            percentage_amount: data.longdate,
            day_count: data.longpercentage
          }
        ]
       })
       setIsEditPlaceCompleter(true);
    
      
  };
  return (
    <div className="createsteps">
      <h2>تخفیف رزرو</h2>
      <p>
        در این بخش می توانید برای رزرو های مدت یا برای دوره های زمانی خاص تخفیف
        لحاظ کنید .{" "}
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
      تخفیف رزرو کوتاه مدت ( اختیاری )      </h4>
    <form onSubmit={handleSubmit(onSubmit)}>
    <div className="createsteps--grid3 mt-[50px]">
        <InputWithlabelin
          name="shortdate"
          control={control}
          errors={errors}
          placeholder=" مثلا ۵"
          label="حداقل مدت رزرو"
          labelIn="روز"
          className="seconadary-input"
        />
        <InputWithlabelin
          name="shortpercentage"
          control={control}
          errors={errors}
          placeholder="مثلا ۶۰۰/۰۰۰"
          label="درصد تخفیف"
          labelIn="درصد"
          className="seconadary-input"
        />
      </div>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
      تخفیف رزرو بلند مدت ( اختیاری )   </h4>
      <div className="createsteps--grid3 mt-[50px]">
        <InputWithlabelin
          name="longdate"
          control={control}
          errors={errors}
          placeholder=" مثلا ۵"
          label="حداقل مدت رزرو"
          labelIn="روز"
          className="seconadary-input"
        />
        <InputWithlabelin
          name="longpercentage"
          control={control}
          errors={errors}
          placeholder="مثلا ۶۰۰/۰۰۰"
          label="درصد تخفیف"
          labelIn="درصد"
          className="seconadary-input"
        />
      </div>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
    {id &&  <Button varient="primary"onClick={handleSubmit((d) =>update(d))}> 
                بروزرسانی اقامتگاه
              </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button onClick={handleSubmit((d) =>onSubmit(d))} varient="primary" type='submit'>
          مرحله بعدی
        </Button>
      </div>
    </form>
    </div>
  );
};

export default CreateStepPart2;
